<template>
  <div id="page-wrap">
    <div class="container" v-if="showCodeStatus">
      <div class="codebox">
        <h1 class="title">请输入提取密码</h1>
        <div class="codebody">
          <div class="form-group">
            <input
              ref="input"
              class="form-control"
              type="password"
              v-model.trim="code"
              readonly
              autofocus
              onfocus="this.removeAttribute('readonly');"
              name="code"
              data-vv-as="密码 "
              v-validate="{ required: true }"
              @keyup.enter="setShareCode"
            />
            <button class="btn btn-primary" type="button" @click="setShareCode">
              提取文件
            </button>
          </div>
          <span class="help-block" v-show="errors.has('code')">{{
            errors.first("code")
          }}</span>
        </div>
      </div>
    </div>
    <div class="container" v-if="expiredStatus">
      <div class="cont">
        <div class="drive">
          <div class="lists">
            <div class="list-content">
              <div class="nofile">
                <div class="pic">
                  <img src="@/assets/images/timeout.svg" />
                </div>
                <h4>{{ errMsg }}</h4>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid group-wrap" v-if="showLinkInfoStatus">
      <div class="container">
        <div class="sharelink-file">
          <div class="filename">
            <div class="file-icon">
              <svg aria-hidden="true" class="icon">
                <use xlink:href="#icon-folder-zy" />
              </svg>
            </div>
            <p>{{ shareInfo.share_title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="showLinkInfoStatus">
      <div class="sharelink-box">
        <div class="cont">
          <div class="filepath">
            <a @click="getInfoByFatherId('up')" :class="{ 'no-click': noClick }"
              >返回上一级</a
            >
            <span class="line">|</span>
            <a @click="getAllInfo">全部文件</a>
            <span v-for="lel in level" :key="lel.number">
              <i class="ti-angle-right"></i>
              <a @click="getInfoByFatherId(lel)">{{ lel.name }}</a>
            </span>
          </div>
          <List :isShowList="true" :isList="isList" @showList="showList"></List>
          <div class="drive">
            <div :class="[isList ? 'lists' : 'grids']">
              <div class="list-header" :class="{ act: selectedCount }">
                <div
                  class="item-header"
                  :class="[
                    { 'item-check-header-selected2': selectedCount },
                    { 'item-check-header-no-selected2': !selectedCount },
                  ]"
                >
                  <div class="checkbox" @click="toggleSelectAll">
                    <i class="ti-check"></i>
                  </div>
                  <div
                    class="item-selected-number"
                    style="display: block"
                    v-show="selectedCount"
                  >
                    已选择{{ selectedCount }}项
                  </div>
                </div>
                <div
                  v-for="header in headers"
                  :key="header.id"
                  class="item-header"
                  :class="'item-' + header.class + '-header'"
                  v-show="!selectedCount && (isList || header.id === 1)"
                  @click="sortByHeader(header.id)"
                >
                  <div class="file-icon" v-show="header.id === 1">
                    <i class="fa fa-file-o"></i>
                  </div>
                  <p>{{ header.title }}</p>
                  <span
                    class="sort"
                    :class="header.sort"
                    v-show="header.showSort"
                  ></span>
                </div>
                <div
                  class="item-selected-menu"
                  style="display: block"
                  v-show="right__share_saveResource && selectedCount"
                >
                  <a @click="handleSelectedData()" v-if="!isMyself">
                    <i class="ti-folder"></i>
                    保存到网盘
                  </a>
                  <a v-show="showMultipleMenu" @click="downloadShareSelecteds">
                    <i class="ti-download"></i>
                    下载
                  </a>
                  <a v-show="right__share_resource_report_create && showMultipleMenu" @click="handleSelectedComplaint">
                    <i class="iconfont icon-jvbao"></i>
                    举报
                  </a>
                </div>
              </div>
              <div class="list-content">
                <div
                  class="itemlist grid-5"
                  :class="{
                    act: data.isSelected ? true : false,
                    itemlist2: !isList && isThumb(data.file_ext),
                  }"
                  v-for="data in datas"
                  :key="data.number"
                >
                  <div class="item-check2">
                    <div class="checkbox" @click="selectRow(data)">
                      <i class="ti-check"></i>
                    </div>
                  </div>
                  <div
                    class="item-name"
                    :style="imgPathFilter(data)"
                    @click.stop="handleClickIcon(data)"
                  >
                    <div
                      class="file-icon"
                      v-if="(!isThumb(data.file_ext) && !isList) || isList"
                    >
                      <svg aria-hidden="true" class="icon">
                        <use
                          :xlink:href="
                            '#icon-' +
                            getIcon(data.type, data.file_type, data.file_ext)
                          "
                        />
                      </svg>
                    </div>
                    <p>
                      <a :title="data | formatData">{{ data | formatData }}</a>
                    </p>
                    <!-- <span
                      v-if="data.file_type === 'video'"
                      :class="data | transcodeStatusFilter"
                      :title="data.transcode_title"
                      @click.stop="shareFileTranstate(data, $event)"
                    ></span> -->
                    <i
                      class="glyphicon glyphicon-lock"
                      :title="data.lock_reason ? data.lock_reason : '锁定'"
                      v-if="
                        data.is_lock === true || data.review_status === 'block'
                      "
                    ></i>
                  </div>
                  <div class="item-size" v-if="isList">
                    {{ data | bytesToSize }}
                  </div>
                  <div class="item-share2" v-if="isList">
                    <span class="item-date-sm">{{
                      data.last_update_date ? data.last_update_date : "-"
                    }}</span>
                  </div>
                  <div class="item-menu">
                    <div class="dropdown">
                      <a
                        aria-expanded="true"
                        aria-haspopup="true"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        id="dropdownMenu2"
                      >
                        <i class="iconfont icon-more" title="更多"></i>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li v-if="right__share_saveResource && !isMyself">
                          <a class="hidden-xs" @click.stop="handleData(data)">
                            <i class="ti-folder" title="保存到网盘"></i
                            >保存到网盘
                          </a>
                        </li>
                        <li v-if="data.type === 'file'">
                          <a class="hidden-xs" @click.stop="download(data)">
                            <i class="ti-download" title="下载"></i>下载
                          </a>
                        </li>
                        <li v-if="data.type === 'file'">
                          <a
                            class="hidden-xs"
                            @click.stop="handleComplaint(data)"
                          >
                            <i class="iconfont icon-jvbao" title="举报"></i>举报
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="loadingbox" v-show="loading">
                  <section class="loading Animation1">
                    <section class="shape shape-1"></section>
                    <section class="shape shape-2"></section>
                    <section class="shape shape-3"></section>
                    <section class="shape shape-4"></section>
                  </section>
                  <h4>正在加载，请稍后……</h4>
                </div>
                <div class="nofile" v-show="nothing">
                  <div class="pic">
                    <img src="@/assets/images/nofile.svg" />
                  </div>
                  <h4>这里还没任何文件</h4>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user">
          <div class="head">
            <div class="avator">
              <img :src="shareInfo.share_creater_avatar" />
            </div>
            <div class="info">
              <h3>{{ shareInfo.share_creater_name }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--举报-->
    <div
      v-if="showLinkInfoStatus"
      aria-labelledby="myModalLabel"
      class="modal fade"
      id="complaint"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <i class="iconfont icon-close"></i>
            </button>
            <h4 class="modal-title" id="myModalLabel">
              被举报人：{{ shareInfo.share_creater_name }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <textarea
                class="form-control"
                placeholder="举报内容"
                rows="5"
                style="resize: none"
                v-model="form.message"
                name="message"
                data-vv-as="举报内容 "
                v-validate="{ required: true, min: 1, max: 100 }"
              ></textarea>
              <span class="help-block" v-show="errors.has('message')">{{
                errors.first("message")
              }}</span>
            </div>
            <div class="form-group">
              <select
                class="form-control"
                v-model="form.type"
                name="type"
                data-vv-as="举报类型 "
                v-validate="'required|included:1,2,3,4,0'"
              >
                <option v-for="type in types" :key="type.id" :value="type.id">
                  {{ type.content }}
                </option>
              </select>
              <span class="help-block" v-show="errors.has('type')">{{
                errors.first("type")
              }}</span>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" type="button">
              关闭
            </button>
            <button
              class="btn btn-primary"
              type="button"
              @click="createShareReport"
            >
              提交
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 保存到 -->
    <div
      aria-labelledby="myModalLabel"
      class="modal fade"
      id="save"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title" id="myModalLabel">保存到</h4>
          </div>
          <div class="modal-body">
            <div class="file-move">
              <div class id="treeview-save"></div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" type="button">
              取消
            </button>
            <button
              class="btn btn-primary"
              type="button"
              @click="saveToFolder"
              :disabled="isProcessing"
            >
              {{ isProcessing ? "正在保存..." : "确定" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <markdownPreview
      :detail="detail"
      dialogStatus="view"
      :linkShareNumber="listQuery.share_number"
    ></markdownPreview>
    <videoPreview
      :detail="detail"
      :linkShareNumber="listQuery.share_number"
    ></videoPreview>
    <audioPreview
      :detail="detail"
      :linkShareNumber="listQuery.share_number"
    ></audioPreview>
    <imgPreview
      :imgs="imgs"
      :linkShareNumber="listQuery.share_number"
    ></imgPreview>
    <txtPreview
      :detail="detail"
      :linkShareNumber="listQuery.share_number"
    ></txtPreview>
    <officePreview
      :detail="detail"
      :linkShareNumber="listQuery.share_number"
    ></officePreview>
    <pdfPreview
      :detail="detail"
      dialogStatus="view"
      :linkShareNumber="listQuery.share_number"
    ></pdfPreview>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import Cookies from "js-cookie";
import { getIcon, getPreviewType } from "@/utils/icon";
import { previewTxts, replaceThumbDomain, config } from "@/config/index";
import { getFileInfo } from "@/api/drive/drive";
import {
  shareTargetInfo,
  shareTargetResourceList,
  shareDownload,
  createShareReport,
  saveShareResource,
  sharePreview,
  shareFileTranstate,
  shareTranstateStatus,
} from "@/api/share/share";
import { setRedirect } from "@/utils/auth";
import {
  bytesToSize,
  listToTree,
  transcodeStatusFilter,
  formatData,
  formatSeconds,
  isThumb,
} from "@/utils/index";

export default {
  name: "ShareLink",
  components: {
    markdownPreview: () =>
      import("@/components/Table/TablePreview/markdownPreview"),
    List: () => import("@/views/Common/List"),
    videoPreview: () => import("./TablePreview/videoPreview"),
    audioPreview: () => import("./TablePreview/audioPreview"),
    imgPreview: () => import("./TablePreview/imgPreview"),
    txtPreview: () => import("./TablePreview/txtPreview"),
    officePreview: () => import("./TablePreview/officePreview"),
    pdfPreview: () => import("./TablePreview/pdfPreview"),
  },
  data() {
    return {
      isProcessing: false,
      isList: true,
      code: "",
      errMsg: "",
      showCodeStatus: false, // 是否显示输入密码框
      expiredStatus: false, // 是否过期
      showLinkInfoStatus: false, // 是否正常获取分享详情
      loading: false,
      nothing: false,
      selectedFolder: null,
      form: {
        type: 1,
        message: null,
      },
      types: [
        {
          id: 1,
          content: "传播危害国家安全、以及侮辱、诽谤、淫秽、暴力的内容",
        },
        { id: 2, content: "传播侵害他人名誉、知识产权等内容" },
        { id: 3, content: "虚构事实、误导、欺骗他人" },
        { id: 4, content: "发表、传播广告信息及垃圾信息" },
        { id: 0, content: "其他" },
      ],
      shareInfo: {},
      sort: {},
      level: [],
      imgs: [],
      selectedDatas: [],
      datas: [],
      PreviewType: "unknow",
      detail: {},
      listQuery: {
        share_number: null,
        share_resource_number: null,
        is_rec: "false",
        share_constraint: {
          password: null,
        },
      },
      headers: [
        {
          id: 1,
          title: "名称",
          class: "name",
          sort: "asc",
          showSort: false,
          field: "name",
        },
        {
          id: 2,
          title: "大小",
          class: "size",
          sort: "des",
          showSort: false,
          field: "bytes",
        },
        {
          id: 3,
          title: "修改日期",
          class: "share",
          sort: "des",
          showSort: true,
          field: "last_update_date",
        },
      ],
    };
  },
  created() {
    this.sort = this.headers[2];
    this.listQuery.share_number = this.$route.params.share_number;
    this.error = this.$route.query.error ? this.$route.query.error : 0;
    this.init();
  },
  filters: {
    transcodeStatusFilter: transcodeStatusFilter,
    formatData: formatData,
    bytesToSize: bytesToSize,
  },
  methods: {
    isThumb: isThumb,
    imgPathFilter(data) {
      return !this.isList &&
        data.file_type === "image" &&
        isThumb(data.file_ext)
        ? `background: center / cover no-repeat url("${data.imgPath}"), #f1f1f1;`
        : "";
    },
    showList(isList) {
      this.isList = isList;
      if (!isList) {
        this.getShareImgPath();
      }
    },
    /**
     * 获取分享的缩略图地址
     */
    getShareImgPath() {
      this.datas.map((item, index, arr) => {
        if (
          item.file_type === "image" &&
          !item.imgPath &&
          isThumb(item.file_ext)
        ) {
          shareDownload({
            share_number: this.listQuery.share_number,
            share_resources_list: [item.number],
          }).then((res) => {
            if (res.status_code === 200) {
              let path = res.entity[item.number];
              arr[index]["imgPath"] = replaceThumbDomain(path);
            }
          });
        }
      });
    },
    shareFileTranstate(data, event) {
      let e = event.target;
      $(e).css({ "pointer-events": "none" });
      setTimeout(() => {
        $(e).css({ "pointer-events": "auto" });
      }, 5000);
      if (data.transcode_status == "wait" || data.transcode_status == "fail") {
        this.$confirm({
          type: "confirm",
          content: "确定要提交转码吗？",
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            shareFileTranstate({
              share_number: this.shareInfo.share_number,
              share_constraint: {
                password: Cookies.get(this.shareInfo.share_number),
              },
              share_resource_number: data.number,
            })
              .then((res) => {
                if (res.status_code === 202) {
                  data.transcode_title = "视频正在转码，请稍等";
                  data.transcode_status = "progess";
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          })
          .catch(() => {});
      } else if (data.transcode_status == "progess") {
        this.shareTranstateStatus(data);
      }
    },
    shareTranstateStatus(data) {
      let params = {
        share_number: this.listQuery.share_number,
        share_constraint: {
          password: Cookies.get(this.listQuery.share_number),
        },
        share_resource_number: data.number,
      };
      shareTranstateStatus(params)
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.trans_status == "progess") {
              this.$message({
                type: "warning",
                message: `该视频正在转码，已完成${
                  res.entity.trans_percentage
                }%，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
              });
            } else if (res.entity.trans_status == "success") {
              this.$message({
                type: "success",
                message: `该视频已转码完成，可以播放`,
              });
            } else if (res.entity.trans_status == "wait") {
              this.$message({
                type: "warning",
                message: `该视频正在等待转码，前面排队的数量${
                  res.entity.trans_queue_count
                }，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
              });
            } else if (res.entity.trans_status == "fail") {
              data.transcode_status = "fail";
              data.transcode_title = "视频转码失败，点击重试";
              this.$message({
                type: "error",
                message: res.entity.trans_message,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    createShareReport() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          let params = {
            share_number: this.shareInfo.share_number,
            share_resources_list: this.targets.map((item) => item.number),
            report_content: this.form.message,
            report_type: this.form.type,
          };
          createShareReport(params)
            .then((res) => {
              if (res.status_code === 200) {
                $("#complaint").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.form.message = "";
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
    download(data) {
      let params = {
        share_number: this.listQuery.share_number,
        share_constraint: {
          password: Cookies.get(this.listQuery.share_number),
        },
        share_resources_list: [data.number],
      };
      shareDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    downloadShareSelecteds() {
      let lockFile = this.selectedDatas.find(
        (item) => item.is_lock || item.review_status === "block"
      );
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (lockFile && lockFile.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (this.selectedCount > 1) {
        this.$confirm({
          type: "confirm",
          content: `确定批量下载这${this.selectedCount}个文件吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            this.downloadShareSelectedsByStep();
          })
          .catch(() => {});
      } else {
        this.downloadShareSelectedsByStep();
      }
    },
    downloadShareSelectedsByStep() {
      this.selectedDatas.map((data) => {
        let params = {
          share_number: this.listQuery.share_number,
          share_constraint: {
            password: Cookies.get(this.listQuery.share_number),
          },
          share_resources_list: [data.number],
        };
        shareDownload(params)
          .then((res) => {
            if (res.status_code === 200) {
              const iframe = window.document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = res.entity[data.number] + "&download=download";
              document.body.appendChild(iframe);
              // 10s之后删除
              setTimeout(() => {
                iframe.remove();
              }, 10000);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    // 存储&验证password
    setShareCode() {
      this.$validator.validate("code").then((valid) => {
        if (valid) {
          Cookies.set(this.listQuery.share_number, this.code);
          this.getShareTargetInfo();
        }
      });
    },
    // 进入页面初始化请求，不显示错误信息
    init() {
      shareTargetInfo({
        share_number: this.listQuery.share_number,
        share_constraint: {
          password: Cookies.get(this.listQuery.share_number),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.share_type !== "link") {
              this.$message({
                type: "warning",
                message: "您没有权限访问此页面，正在跳转到首页...",
              });
              setTimeout(() => {
                this.$router.push({ name: "index" });
              }, 3000);
              return false;
            }
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.shareInfo = res.entity;
            this.getShareResource();
          } else if (res.status_code === 439) {
            // 过期
            this.showCodeStatus = false;
            this.errMsg = res.message;
            this.expiredStatus = true;
          } else if (res.status_code === 434) {
            // 密码错误
            this.showCodeStatus = true;
          } else {
            this.showCodeStatus = false;
            this.errStatus = true;
            this.errMsg = res.message;
            this.$message({
              type: "error",
              message: res.message + " 正在跳转到首页...",
            });
            setTimeout(() => {
              this.$router.push({ name: "index" });
            }, 3000);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取分享详情
    getShareTargetInfo() {
      shareTargetInfo({
        share_number: this.listQuery.share_number,
        share_constraint: {
          password: Cookies.get(this.listQuery.share_number),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.shareInfo = res.entity;
            this.getShareResource();
          } else if (res.status_code === 439) {
            // 过期
            this.showCodeStatus = false;
            this.errMsg = res.message;
            this.expiredStatus = true;
          } else if (res.status_code === 434) {
            // 密码错误
            this.showCodeStatus = true;
            this.errors.add({
              field: "code",
              msg: res.message,
            });
          } else {
            this.showCodeStatus = false;
            this.errStatus = true;
            this.errMsg = res.message;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getShareResource() {
      this.selectedDatas = [];
      this.datas = [];
      this.loading = true;
      this.nothing = false;
      this.listQuery.share_constraint.password = Cookies.get(
        this.listQuery.share_number
      );
      shareTargetResourceList(this.listQuery)
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            if (res.entity.length) {
              this.datas = res.entity.map((item) => {
                item.isSelected = false;
                if (item.file_type === "image") {
                  item.imgPath = null;
                }
                return item;
              });
              this.sortBy();
              if (!this.isList) {
                this.getShareImgPath();
              }
            } else {
              this.nothing = true;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    sortByHeader(id) {
      let that = this;
      this.headers.map(function (item) {
        if (item.id === id) {
          that.sort = item;
          item.showSort = true;
          item.sort = item.sort === "des" ? "asc" : "des";
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
      this.sortBy();
    },
    sortBy() {
      let that = this;
      switch (this.sort.id) {
        case 1:
          this.datas.sort(function (x, y) {
            let ind = x[that.sort.field].localeCompare(y[that.sort.field]);
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
        case 2:
          this.datas.sort(function (x, y) {
            let ind = x[that.sort.field] - y[that.sort.field];
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
        case 3:
          this.datas.sort(function (x, y) {
            let ind =
              new Date(x[that.sort.field]).getTime() -
              new Date(y[that.sort.field]).getTime();
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
      }
      const files = this.datas.filter((item) => {
        return item.type === "file";
      });

      const folders = this.datas.filter((item) => {
        return item.type === "folder";
      });

      this.datas = folders.concat(files);
    },
    getAllInfo() {
      this.level = [];
      this.listQuery.share_resource_number = null;
      this.getShareResource();
    },
    handleClickIcon(data) {
      if (data.type === "file") {
        this.preview(data);
      } else {
        this.getInfoByFatherId(data);
      }
    },
    getInfoByFatherId(data) {
      this.selectedDatas = [];
      let index = this.level.indexOf(data);
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      this.listQuery.share_resource_number =
        this.level.length === 0
          ? null
          : this.level[this.level.length - 1].number;
      this.getShareResource();
    },
    preview(data) {
      this.detail = data;
      let type = getPreviewType(data.type, data.file_type, data.file_ext);
      this.PreviewType = type;
      switch (type) {
        case "mp4":
          if (
            data.transcode_status == "none" ||
            data.transcode_status == "success"
          ) {
            this.getPreviewPath(data).then(() => {
              $("#video_preview").modal("show");
            });
          } else if (data.transcode_status == "wait") {
            this.$message({
              type: "warning",
              message: "视频暂未转码，请先点击转码，转码完成后即可播放",
            });
          } else if (data.transcode_status == "progess") {
            this.$message({
              type: "warning",
              message: "视频正在转码，请稍等",
            });
          } else if (data.transcode_status == "fail") {
            this.$message({
              type: "error",
              message: "视频转码失败，无法播放",
            });
          } else if (data.transcode_status == "notran") {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
            });
          }
          break;
        case "audio":
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#audio_preview").modal("show");
            });
          });
          break;
        case "office":
          this.getPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#office_preview").modal("show");
            });
          });
          break;
        case "pdf":
          this.getPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#pdf_preview").modal("show");
            });
          });
          break;
        case "markdown":
          this.getPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#markdown_preview").modal("show");
            });
          });
          break;
        case "img":
          this.getPreviewPath(data).then(() => {
            this.imgs = this.datas
              .filter((item) => {
                return item.file_type === "image";
              })
              .map((file) => {
                if (file.number === data.number) {
                  file.show = true;
                } else {
                  file.show = false;
                }
                return file;
              });
            this.$nextTick(() => {
              $("#img_preview").modal("show");
            });
          });
          break;
        case "txt":
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#txt_preview").modal("show");
            });
          });
          break;
        default:
          if (previewTxts.includes(data.file_ext)) {
            this.getPreviewPath(data).then(() => {
              this.$nextTick(() => {
                $("#txt_preview").modal("show");
              });
            });
          } else {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
            });
          }
          break;
      }
    },
    getPreviewPath(data) {
      return new Promise((resolve) => {
        let share_constraint = null;
        let password = Cookies.get(this.listQuery.share_number);
        if (password) {
          share_constraint = {
            password: password,
          };
        }
        sharePreview({
          share_number: this.listQuery.share_number,
          share_resource_number: this.detail.number,
          share_constraint: share_constraint,
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              if (data.review_status === "block") {
                this.$message({
                  type: "warning",
                  message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else if (res.status_code === 410) {
              this.$message({
                type: "error",
                message: res.message,
              });
              let index = this.datas.indexOf(data);
              this.datas.splice(index, 1);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    selectRow(data) {
      if (data.isSelected) {
        let index = this.selectedDatas.indexOf(data);
        data.isSelected = false;
        this.selectedDatas.splice(index, 1);
      } else {
        data.isSelected = true;
        this.selectedDatas.push(data);
      }
    },
    toggleSelectAll() {
      let status = this.selectedDatas.length === 0;
      if (status) {
        this.selectedDatas = this.datas.map((data) => {
          return data;
        });
      } else {
        this.selectedDatas = [];
      }
      this.datas.map((data) => {
        data.isSelected = status ? true : false;
        return data;
      });
    },
    handleComplaint(data) {
      if (this.$store.state.user.authenticated) {
        this.targets = [data];
        $("#complaint").modal("show");
      } else {
        setRedirect(`${window.location.origin}${this.$route.fullPath}`);
        this.$message({
          type: "warning",
          message: "该操作需要登录，正在跳转登录...",
        });
        setTimeout(() => {
          // this.$router.push({ name: "login" });
          const routeUrl = this.$router.resolve({
            name: "login_terminal",
          });
          window.location.href =
            `${config.loginUrl}` +
            encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
        }, 3000);
      }
    },
    handleSelectedComplaint() {
      if (this.$store.state.user.authenticated) {
        this.targets = this.selectedDatas;
        $("#complaint").modal("show");
      } else {
        setRedirect(`${window.location.origin}${this.$route.fullPath}`);
        this.$message({
          type: "warning",
          message: "该操作需要登录，正在跳转登录...",
        });
        setTimeout(() => {
          // this.$router.push({ name: "login" });
          const routeUrl = this.$router.resolve({
            name: "login_terminal",
          });
          window.location.href =
            `${config.loginUrl}` +
            encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
        }, 3000);
      }
    },
    handleData(data) {
      if (this.$store.state.user.authenticated) {
        if (data.is_lock) {
          this.$message({
            type: "warning",
            message: `文件【${data.name}】已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
          });
          return false;
        }
        if (data && data.review_status === "block") {
          this.$message({
            type: "warning",
            message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
          });
          return false;
        }
        this.targets = [data];
        this.getTree();
      } else {
        setRedirect(`${window.location.origin}${this.$route.fullPath}`);
        this.$message({
          type: "warning",
          message: "该操作需要登录，正在跳转登录...",
        });
        setTimeout(() => {
          // this.$router.push({ name: "login" });
          const routeUrl = this.$router.resolve({
            name: "login_terminal",
          });
          window.location.href =
            `${config.loginUrl}` +
            encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
        }, 3000);
      }
    },
    handleSelectedData() {
      if (this.$store.state.user.authenticated) {
        let lockFile = this.selectedDatas.find(
          (item) => item.is_lock || item.review_status === "block"
        );
        if (lockFile && lockFile.is_lock) {
          this.$message({
            type: "warning",
            message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
          });
          return false;
        }
        if (lockFile && lockFile.review_status === "block") {
          this.$message({
            type: "warning",
            message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
          });
          return false;
        }
        this.targets = this.selectedDatas;
        this.getTree();
      } else {
        setRedirect(`${window.location.origin}${this.$route.fullPath}`);
        this.$message({
          type: "warning",
          message: "该操作需要登录，正在跳转登录...",
        });
        setTimeout(() => {
          // this.$router.push({ name: "login" });
          const routeUrl = this.$router.resolve({
            name: "login_terminal",
          });
          window.location.href =
            `${config.loginUrl}` +
            encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
        }, 3000);
      }
    },
    getTree() {
      let that = this;
      getFileInfo({
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: "我的云盘",
              nodes: listToTree(res.entity.datas, []),
            },
          ];
          $("#treeview-save").treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.selectedFolder = data;
            },
            onNodeUnselected: function (event, data) {
              that.selectedFolder = null;
            },
            data: tree,
          });
          $("#save").modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    saveToFolder() {
      if (this.isProcessing) {
        return false;
      }
      this.isProcessing = true;
      if (!this.selectedFolder) {
        this.$message({
          type: "warning",
          message: "请选择目标文件夹",
        });
        this.isProcessing = false;
        return false;
      }
      let paramslist = this.targets.map(function (item) {
        return {
          share_resource_number: item.number,
          share_resource_type: item.type,
        };
      });
      let params = {
        share_number: this.shareInfo.share_number,
        // share_password: "string",
        target_number: this.selectedFolder.number,
        disk_type: this.selectedFolder.disk_type,
        paramslist: paramslist,
      };
      saveShareResource(params)
        .then((res) => {
          if (res.status_code === 200) {
            this.isProcessing = false;
            $("#save").modal("hide");
            this.selectedFolder = null;
            this.$message({
              type: "success",
              message: res.message,
            });
            if (res.entity.state === 2) {
              return false;
            }
            Bus.$on("jobSuccess", () => {
              this.$emit("reloadInfo");
            });
            this.$store.commit("addTask", {
              job_id: res.entity.job_id,
              job_type: "",
              run_percent: res.entity.run_percent,
              state: res.entity.state,
              message: "",
            });
            Bus.$emit("changeGlobalPluginStatus", {
              plugin: "showGlobalQueue",
              status: true,
            });
          } else {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  computed: {
    right__share_saveResource () {
      return this.$store.getters.right__share_saveResource
    },
    right__share_resource_report_create () {
      return this.$store.getters.right__share_resource_report_create
    },
    isMyself() {
      return (
        this.shareInfo.share_creater_number ===
        this.$store.state.user.userInfo.user_number
      );
    },
    noClick() {
      return this.level.length ? false : true;
    },
    selectedCount() {
      return this.selectedDatas.length;
    },
    showMultipleMenu() {
      return this.selectedDatas.every((item) => item.type === "file");
    },
  },
};
</script>

<style scoped>
/*分享链接*/
.drive .lists .item-check-header-selected2 {
  float: left;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
}
.drive .grids .item-check-header-selected2 {
  float: left;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 20px;
}
.drive .lists .item-check-header-no-selected2,
.drive .lists .item-check2 {
  float: left;
  width: 5%;
  padding-right: 10px;
  padding-left: 10px;
}
@media (max-width: 992px) {
  .item-date-sm {
    line-height: 16px;
    display: inline-block;
    margin: 20px 0;
  }
  .drive .item-share-header {
    display: block;
  }
  .lists .item-name,
  .lists .item-name-header {
    width: 60% !important;
  }
  .lists .item-name p,
  .item-groupname p {
    word-break: break-all;
    word-wrap: break-word;
    white-space: normal;
    line-height: 24px;
    padding: 25px 0;
  }
  .sharelink-box .cont {
    width: calc(100% - 0px);
    margin-top: 100px;
  }
  .sharelink-box .user {
    width: 100%;
    padding: 15px 0;
    background: #f9f9f9;
    position: absolute;
    top: -20px;
    left: 0;
    border-bottom: #e1e1e1 solid 1px;
  }
  .sharelink-file {
    padding: 20px 0;
  }
  .sharelink-box .item-share2 {
    line-height: 35px;
    width: 70px;
  }
  .sharelink-box .itemlist .item-menu .hidden-xs:first-child {
    display: block !important;
  }
  .sharelink-file .filename {
    width: 100%;
  }
  .sharelink-file .filename p {
    width: calc(100% - 40px);
    font-size: 20px;
    padding-left: 15px;
    float: left;
    margin-top: 5px;
    line-height: 30px;
  }
}
@media (min-width: 992px) {
  .sharelink-box .cont {
    width: calc(100% - 166px);
  }
  .sharelink-box .user {
    float: right;
    height: 100%;
    background: #f9f9f9;
    position: absolute;
    right: 0;
    top: 0;
    border-left: #e1e1e1 solid 1px;
  }
  .sharelink-file {
    padding: 50px 0;
    height: 140px;
  }
  .sharelink-file .filename {
    width: 60%;
  }
  .sharelink-file .filename p {
    width: calc(100% - 40px);
    font-size: 20px;
    padding-left: 15px;
    line-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.sharelink-box {
  width: 100%;
  min-height: 500px;
  float: left;
  position: relative;
}
.sharelink-box .cont {
  float: left;
}
.sharelink-box .cont .head {
  width: 100%;
  height: 40px;
}
.sharelink-box .cont .filepath {
  width: calc(100% - 80px);
  float: left;
}
.sharelink-box .cont .drive .lists .item-name-header,
.sharelink-box .cont .drive .lists .item-name {
  width: 45%;
}
.sharelink-box .user .head {
  padding: 0 15px;
  position: relative;
}
.sharelink-box .user .head .avator {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  float: left;
}
.sharelink-box .user .head .avator img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.sharelink-box .user .head .info {
  width: auto;
  padding-left: 20px;
  height: 60px;
  float: left;
}
.sharelink-box .user .head .info h3 {
  font-size: 16px;
  margin: 10px 0 5px 0;
}
.sharelink-box .user .head .info p {
  font-size: 12px;
  color: #999;
}
.sharelink-file {
  width: calc(100% - 0px);
  float: left;
}
.sharelink-user {
  width: 300px;
  float: right;
}
.sharelink-file .filename {
  float: left;
  line-height: 40px;
}
.sharelink-file .filename .file-icon {
  width: 40px;
  height: 40px;
  display: block;
  float: left;
}
.sharelink-file .filename .file-icon .icon {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.no-click {
  color: #ddd;
  cursor: default;
}
.item-share2 {
  float: left;
  width: 18%;
}
.drive .grids .itemlist2 {
  padding: 20px 20px 50px 20px !important;
}
.drive .grids .itemlist2 .item-name {
  width: 100%;
  height: 100%;
  padding-top: 85px;
  background-color: #f1f1f1;
}
.drive .grids .itemlist2 p {
  margin-top: 5px;
}
</style>